import { notInServer } from '../environment'
import { SDKScripts } from '../generated/types'
import { ConsentCookie } from '../types/sdk'
import { Scripts } from './scripts'

class ServerScripts extends Scripts {
  hasConsent(script: SDKScripts, consentCookie: ConsentCookie) {
    if (notInServer()) {
      return false
    }

    const category = this.getScriptCategory(script)
    if (!category) {
      return false
    }

    if (!consentCookie) {
      return false
    }

    const consents = consentCookie.categories

    return consents.includes(category)
  }
}

export const serverScripts = new ServerScripts()
